import StringMask from 'string-mask'

class AlertaList {
    constructor(gql, scope, modal, $filter) {
        this.apply = (fn) => scope.$apply(fn)
        this.gql = gql
        this.scope = scope
        this.modal = modal
        this.$filter = $filter

        this.order = { sortField: 'EMISSAO', sortOrder: 'DESC' }
        this.filter = {}
        this.perPage = 10
        this.nfes = []
    }

    $onChanges({ filter }) {
        this.currentPage = 1

        if (filter && filter.currentValue) {
            this.filter = filter.currentValue

            if (this.filter.empresaId) {
                this.loadingPromise = Promise.all([this.loadEmpresaUsuario(), this.loadAlertas({})])
                this.createOrReplaceSubscriptions()
            }
        }
    }

    $onDestroy() {
        this.tearDownSubscriptions()
    }

    pageChange(page) {
        this.loadingPromise = this.loadAlertas(page)
    }

    emitirDanfe(nfe) {
        this.downloadOperation(this.fetchTokenNfe('DownloadNfeDa', nfe.chave, 'danfe'))
    }

    iniciarSac(nfe) {
        let razaoSocial = encodeURIComponent(this.empresa.razaoSocial)
        let nomeUsuario = encodeURIComponent(this.usuario.nome)

        let url = `https://sac.eficienciafiscal.com.br/sac-servico-de-atendimento-ao-consumidor/
            ?sac-razao-social-empresa=${razaoSocial}&sac-cnpj-empresa=${this.empresa.cnpj}
            &your-name=${nomeUsuario}&your-email=${this.usuario.email}&nfe=${nfe.numero}`

        window.open(url)
    }

    exibirComentarios(nfe) {
        this.modal.open({
            backdrop: 'static',
            size: 'md',
            component: 'nfeComentariosModal',
            resolve: {
                nfe: () => nfe,
                origem: () => "CENTRAL_ALERTAS",
                empresaId: () => this.contratoId
            }
        })
    }

    openAlertaHistoricoModal(alerta) {
        this.modal.open({
            backdrop: 'static',
            size: 'md',
            component: 'alertaHistoricoModal',
            resolve: {
                alerta: () => alerta
            }
        })
    }

    async downloadOperation(tokenPromise) {
        let tab = cbk.initDownloadTab();
        let token = await tokenPromise
        cbk.download(`/api/resume-operation/${token}`, tab)
    }

    async fetchTokenNfe(operation, chave, format) {
        const query = gql`
            query ${operation}($filialId: Int!, $filter: NfeFilter!) {
                empresa: filial(id: $filialId) {
                    id
                    nfe(filter: $filter) {
                        ${format} { token }
                    }
                }
            }
        `

        let { empresa: { nfe } } =
            await this.gql.query(query, { filialId: this.filter.empresaId, filter: { chave } })

        return nfe[format]['token']
    }

    async loadEmpresaUsuario() {
        if (!this.empresa || !this.usuario) {
            const query = gql`
                query EmpresaAndUsuario($filialId: Int!) {
                    empresa: filial(id: $filialId) {
                        id
                        razaoSocial
                        cnpj
                    }
                    
                    usuario: usuarioAtual {
                        id
                        nome
                        email
                    }
                }
            `

            const { empresa, usuario } = await this.gql.query(query, { filialId: this.filter.empresaId })

            this.empresa = empresa
            this.usuario = usuario
        }
    }

    async loadAlertas(page) {
        const query = gql`
            query Alertas($filialId: Int!, $nfeFilter: NfeFilter!, $nfeAlertaFilter: NfeAlertaFilter!, $after: String, $before: String) {
                empresa: filial(id: $filialId) {
                    id
                    nfesPage(filter: $nfeFilter, after: $after, before: $before, limit: ${this.perPage}) {
                        after
                        before
                        nfes: entries {
                            ... on Nfe {
                                id
                                chave
                                numero
                                emissao
                                valor
                                modelo
                                emitente {
                                    id
                                    nome
                                    cpfCnpj
                                    uf
                                }
                                discussao {
                                    id
                                    comentarios {
                                        id
                                        texto
                                        origem
                                        insertedAt
                                        usuario { nome }
                                    }
                                }
                                alertas(filter: $nfeAlertaFilter) {
                                    id
                                    tipo
                                    status
                                    item {
                                        id
                                        codigo
                                        descricao
                                        codigoBarras
                                        ncm
                                        cest
                                    }
                                    medicamentoVencendo {
                                        validade
                                    }
                                    itemSemCest {
                                        ncm
                                        cests
                                    }
                                    nfeSna {
                                        informacoesComplementares
                                    }
                                    nfeSnaSemCreditoDestacado {
                                        csosn
                                    }
                                    ncmDivergente {
                                        ncmCorreto
                                        fonteNome
                                        fonteCnpj
                                    }
                                    cestDivergente {
                                        cestCorreto
                                        fonteNome
                                        fonteCnpj
                                    }
                                    revisoes {
                                        id
                                        status
                                        insertedAt
                                        usuario { nome }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `

        const nfeAlertaFilter = { tipoIs: this.filter.tipoAlerta, status: this.filter.revisaoStatus }
        const nfeFilter = {
            hasAlerta: nfeAlertaFilter,
            emissaoInicial: this.filter.emissaoInicial,
            emissaoFinal: this.filter.emissaoFinal,
            numero: this.filter.numero,
            chave: this.filter.chave,
            emitente: this.filter.emitente,
            tipoEmissao: this.filter.tipoEmissao
        }

        cbk.deleteEmptyKeys(nfeFilter)

        const variables = { filialId: this.filter.empresaId, nfeFilter, nfeAlertaFilter, ...page }
        const { empresa: { nfesPage: { after, before, nfes } } } = await this.gql.query(query, variables)

        this.apply(() => {
            this.nfes = this.updateAlertas(nfes, alerta => this.buildTipoAndDescricao(alerta))
            this.nextPage = after
            this.previousPage = before
            this.currentPage = this.currentPage + (page.after ? 1 : page.before ? -1 : 0)

            if (!page.after && !page.before)
                this.searchContext = new Date()
        })
    }

    async updateStatus(alerta, status) {
        status = alerta.status === status ? 'NAO_REVISADO' : status

        const query = gql`
            mutation UpdateAlertaStatus($empresaId: String!, $alertaId: Int!, $status: AlertaStatus!) {
                empresa(id: $empresaId) {
                    updatedAlerta: updateAlertaStatus(id: $alertaId, status: $status) {
                        id
                        status
                        revisoes {
                            status
                            insertedAt
                            usuario { nome }
                        }
                    }
                }
            }
        `
        const variables = { empresaId: this.contratoId.toString(), alertaId: parseInt(alerta.id), status }

        return await this.gql
            .mutate(query, variables)
            .then(({ empresa: { updatedAlerta } }) => {
                if (updatedAlerta.id) {
                    this.apply(() => { alerta.status = updatedAlerta.status })
                }
            })
    }

    async updateStatusWhere(status) {
        const query = gql`
            mutation($empresaId: String!, $filialId: Int!, $nfeFilter: NfeFilter!, $nfeAlertaFilter: NfeAlertaFilter!, $status: AlertaStatus!) {
                empresa(id: $empresaId) {
                    updatedAlertas: updateAlertaStatusWhere(filialId: $filialId, nfeFilter: $nfeFilter, nfeAlertaFilter: $nfeAlertaFilter, status: $status) {
                        alertasIds
                        status
                        filialId
                    }
                }
            }
        `

        const nfeAlertaFilter = { tipoIs: this.filter.tipoAlerta, status: this.filter.revisaoStatus }
        const nfeFilter = {
            hasAlerta: nfeAlertaFilter,
            emissaoInicial: this.filter.emissaoInicial,
            emissaoFinal: this.filter.emissaoFinal,
            numero: this.filter.numero,
            chave: this.filter.chave,
            emitente: this.filter.emitente
        }

        this.updateStatusWherePromise = this.gql.mutate(query, { empresaId: this.contratoId.toString(), filialId: this.filter.empresaId, nfeFilter, nfeAlertaFilter, status })

        const { empresa: { updatedAlertas } } = await this.updateStatusWherePromise

        if (updatedAlertas.filialId === this.filter.empresaId) {
            this.apply(() => {
                this.nfes = this.updateAlertas(this.nfes, alerta => {
                    if (updatedAlertas.alertasIds.includes(parseInt(alerta.id)))
                        alerta.status = status

                    return alerta
                })
            })

            this.scope.$root.$broadcast('updateStatusWhere', status)
        }
    }

    createOrReplaceSubscriptions() {
        this.tearDownSubscriptions()

        const variables = { filialId: this.filter.empresaId }

        const onEvent = ({ data: { alertaRevisaoStatusUpdated, alertaRevisaoStatusUpdatedMany, nfeComentarioAdicionado } }) => {
            if (alertaRevisaoStatusUpdated) {
                const { id, status, revisoes } = alertaRevisaoStatusUpdated

                this.nfes = this.updateAlertas(this.nfes, alerta => {
                    if (alerta.id === id) {
                        alerta.status = status
                        alerta.revisoes = revisoes
                    }

                    return alerta
                })
            }

            if (alertaRevisaoStatusUpdatedMany) {
                const { alertasIds, status, revisao } = alertaRevisaoStatusUpdatedMany

                this.nfes = this.updateAlertas(this.nfes, alerta => {
                    if (alertasIds.includes(parseInt(alerta.id))) {
                        alerta.status = status
                        alerta.revisoes.push(revisao)
                    }

                    return alerta
                })
            }

            if (nfeComentarioAdicionado) {
                const { discussao } = nfeComentarioAdicionado

                this.nfes = this.nfes.map(nfe => {
                    if (nfe.id === discussao.nfe.id)
                        nfe.discussao = discussao

                    return nfe
                })
            }
        }

        const alertaRevisaoStatusUpdatedSubscription = `
            subscription ($filialId: Int!) {
                alertaRevisaoStatusUpdated(filialId: $filialId) {
                    id
                    status
                    revisoes {
                      id
                      status
                      insertedAt
                      usuario { nome }
                    }
                }
            }
        `

        const alertaRevisaoStatusUpdatedManySubscription = `
            subscription ($filialId: Int!) {
                alertaRevisaoStatusUpdatedMany(filialId: $filialId) {
                    alertasIds
                    status
                    revisao {
                      id
                      status
                      insertedAt
                      usuario { nome }
                    }
                }
            }
        `

        const nfeComentarioAdicionadoSubscription = `
            subscription($filialId: Int!) {
                nfeComentarioAdicionado(filialId: $filialId) { 
                    id
                    discussao { 
                        id
                        nfe { id }
                        comentarios {
                            id
                            texto
                            origem
                            insertedAt
                            usuario { nome }
                        }
                    }
                }
            }
        `

        const callback = data => this.apply(() => onEvent(data))

        this.unsubscribers = [
            this.gql.subscribe(alertaRevisaoStatusUpdatedSubscription, variables, callback),
            this.gql.subscribe(alertaRevisaoStatusUpdatedManySubscription, variables, callback),
            this.gql.subscribe(nfeComentarioAdicionadoSubscription, variables, callback)
        ]
    }

    tearDownSubscriptions() {
        if (this.unsubscribers) this.unsubscribers.forEach(unsubscriber => unsubscriber())
    }

    updateAlertas(nfes, fun) {
        return nfes.map(nfe => {
            if (nfe.alertas) {
                return {
                    ...nfe,
                    alertas: nfe.alertas.map(alerta => {
                        return fun(alerta)
                    })
                }
            }

            return nfe
        })
    }

    buildTipoAndDescricao(alerta) {
        const { tipo, item } = alerta
        let tipoDescricao = ""
        let descricao = ""
        let meta = {}

        switch (tipo) {
            case 'MEDICAMENTO_VENCENDO':
                meta = alerta.medicamentoVencendo
                tipoDescricao = "Medicamento com validade próxima"
                descricao = `O item de medicamento <b>${item.codigo} - ${item.descricao}</b> 
                possui meta de vencimento em <b>${this.formatDate(meta.validade)}</b>.`
                break

            case 'ITEM_SEM_CEST':
                meta = alerta.itemSemCest
                tipoDescricao = "Item sem especificação da CEST"
                descricao = `O item <b>${item.codigo} - ${item.descricao}</b> (<b>NCM ${StringMask.apply(item.ncm, "0000.00.00")}</b>) não possui especificação da CEST.`
                break

            case 'NFE_CANCELADA':
                tipoDescricao = "NF-e cancelada"
                descricao = "Esta NF-e foi cancelada."
                break

            case 'NFE_SNA':
                meta = alerta.nfeSna
                tipoDescricao = "NF-e Simples Nacional"
                descricao = `O fornecedor desta NF-e é enquadrado no Simples Nacional.`
                    + (meta.informacoesComplementares ? `<br/><b>Informações complementares:</b> ${meta.informacoesComplementares}` : '')
                break

            case 'NFE_SNA_SEM_CREDITO_DESTACADO':
                meta = alerta.nfeSnaSemCreditoDestacado
                tipoDescricao = "NF-e SNA sem crédito destacado"
                descricao = `O fornecedor desta NF-e é enquadrado no Simples Nacional, 
                porém o item <b>${item.codigo} - ${item.descricao}</b> (<b>NCM ${item.ncm}</b>) com <b>CSOSN ${meta.csosn}</b> não possui crédito destacado.`
                break

            case 'NCM_DIVERGENTE':
                meta = alerta.ncmDivergente
                tipoDescricao = "NCM divergente"
                descricao = `Segundo o fornecedor <b>${meta.fonteNome} - ${this.$filter('cpfCnpj')(meta.fonteCnpj)}</b>, o item <b>${item.codigo} - ${item.descricao}</b>,
                    de código de barras <b>${item.codigoBarras}</b>, deve possuir o <b>NCM ${StringMask.apply(meta.ncmCorreto, "0000.00.00")}</b>, porém foi encontrado o NCM <b>${StringMask.apply(item.ncm, "0000.00.00")}</b>.`
                break

            case 'CEST_DIVERGENTE':
                meta = alerta.cestDivergente
                tipoDescricao = "Item com CEST divergente"
                descricao = `Segundo o fornecedor <b>${meta.fonteNome} - ${this.$filter('cpfCnpj')(meta.fonteCnpj)}</b>, o item <b>${item.codigo} - ${item.descricao}</b>,
                de código de barras <b>${item.codigoBarras}</b>, deve possuir o <b>CEST ${StringMask.apply(meta.cestCorreto, "00.000.00")}</b>, porém foi encontrado o <b>CEST ${StringMask.apply(item.cest, "00.000.00")}</b>.`
                break
        }

        return { ...alerta, tipoDescricao, descricao }
    }

    formatDate(date) {
        return this.$filter('date')(date, 'dd/MM/yyyy')
    }
}

angular.module('eficienciaFiscalModule')
    .component('alertaList', {
        controller: ['gql', '$scope', '$uibModal', '$filter', AlertaList],
        bindings: {
            empresa: '<',
            filter: '<',
            contratoId: '<'
        },
        //language=HTML
        template: () => {
            const batchUpdateOptions = () => {
                return `
                    <promise-tracker promise="$ctrl.updateStatusWherePromise" active="updatingAlertas">
                        <div style="display: flex; align-items: center; justify-content: flex-end; margin: 0 0 9px;">
                            <span>Marcar todos os resultados da consulta como:</span>
                            <div style="display: flex; text-decoration: underline; color: #3276b1;">
                                <button ng-hide="updatingAlertas" ng-click="$ctrl.updateStatusWhere('NAO_REVISADO')" class="btn btn-xs btn-link">
                                    Não revisado
                                </button>
                                <button ng-hide="updatingAlertas" ng-click="$ctrl.updateStatusWhere('REVISADO')" class="btn btn-xs btn-link">
                                    Revisado
                                </button>
                                <button ng-hide="updatingAlertas" ng-click="$ctrl.updateStatusWhere('ANALISE')" class="btn btn-xs btn-link">
                                    Em análise
                                </button>
                                <button ng-show="updatingAlertas" disabled class="btn btn-xs btn-link">
                                    <i class="fa fa-circle-o-notch fa-spin"></i> Processando...
                                </button>
                            </div>
                        </div>
                    </promise-tracker>
                `
            }

            return `
                <loading promise="$ctrl.loadingPromise">
                    <highlighted ng-show="!$ctrl.empresa">
                        <main>Preencha o filtro acima para realizar uma consulta.</main>
                    </highlighted>
                    
                    <highlighted ng-show="$ctrl.nfes.length == 0 && $ctrl.empresa">
                        <main>Nenhuma informação encontrada.</main>
                    </highlighted>
                    <div ng-show="$ctrl.nfes.length > 0">
                        ${batchUpdateOptions()}
                        <cursor-paginator per-page="$ctrl.perPage" next-page="$ctrl.nextPage" previous-page="$ctrl.previousPage"
                            current-page="$ctrl.currentPage" current-page-size="$ctrl.nfes.length" 
                            on-change="$ctrl.pageChange($page)" search-context="$ctrl.searchContext">
                        </cursor-paginator>
                        <div>
                            <div class="well ng-scope" ng-repeat="nfe in $ctrl.nfes" style="padding: 15px;">
                                <div class="row">
                                    <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 10px;"
                                         class="text-primary">
                                        <hr style="margin: 0 10px 0 0;flex-grow: 0; width: 25px">
                                        <h5 style="flex-shrink: 1; margin: 0;">NF-e</h5>
                                        <hr style="margin: 0 0 0 10px;flex-grow: 1;">
                                    </div>
                                    <div style="display: flex; align-items: center;">
                                        <div class="col col-md-8 clearfix">
                                            <div class="row">
                                                <div class="col col-sm-3">
                                                    <span class="text-bold">Número: </span>
                                                    <span>
                                                      <span class="ng-binding">{{ nfe.numero }}</span>
                                                    </span>
                                                </div>
                                                <div class="col col-sm-3">
                                                    <span class="text-bold">Emissão: </span>
                                                    <span>
                                                      <span class="ng-binding">{{ nfe.emissao | date }}</span>
                                                    </span>
                                                </div>
                                                <div class="col col-sm-3">
                                                    <span class="text-bold">Valor: </span>
                                                    <span>
                                                      <span class="ng-binding">{{ nfe.valor | currency }}</span>
                                                    </span>
                                                </div>
                                                <div class="col col-sm-6">
                                                    <span class="text-bold">Razão Social: </span>
                                                    <span>
                                                      <span class="ng-binding">{{ nfe.emitente.nome }}</span>
                                                    </span>
                                                </div>
                                                <div class="col col-sm-4">
                                                    <span class="text-bold">CPF/CNPJ: </span>
                                                    <span>
                                                      <span class="ng-binding">{{ nfe.emitente.cpfCnpj | cpfCnpj }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col col-md-4">
                                            <div style="display: flex; justify-content: flex-end; flex-flow: wrap">
                                                <button class="btn btn-default" style="margin: 2px"
                                                        ng-click="$ctrl.emitirDanfe(nfe)">{{nfe.modelo == 'nfe' ? 'DANFE' : 'DANFCE'}}
                                                </button>
                                                <button class="btn btn-default" style="margin: 2px"
                                                        ng-click="$ctrl.iniciarSac(nfe)">SAC
                                                </button>
                                                <button class="btn btn-default" style="margin: 2px"
                                                        ng-click="$ctrl.exibirComentarios(nfe)">Comentários
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="row">
                                        <div style="display: flex; flex-direction: row; align-items: center; 
                                             margin-top: 10px; margin-bottom: 10px;" class="text-primary">
                                            <hr style="margin: 0 10px 0 0;flex-grow: 0; width: 25px">
                                            <h5 style="flex-shrink: 1; margin: 0;">
                                                ALERTAS
                                            </h5>
                                            <hr style="margin: 0 0 0 10px; flex-grow: 1;">
                                        </div>
                                        <table class="table table-hover table-condensed" style="margin: 0">
                                            <thead>
                                            <tr>
                                                <th class="text-center" width="1">#</th>
                                                <th class="no-break" width="222px">Tipo do alerta</th>
                                                <th>Descrição</th>
                                                <th class="text-center" width="1">Revisão</th>
                                                <th class="text-center" width="1">Histórico</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr ng-repeat="alerta in nfe.alertas" class="ng-scope">
                                                <td class="text-center-middle">{{ $index + 1 }}</td>
                                                <td ng-bind-html="alerta.tipoDescricao" class="no-break text-middle"></td>
                                                <td ng-bind-html="alerta.descricao"></td>
                                                <td class="text-center-middle pull">
                                                    <i class="fa fa-check text-success cursor-pointer"
                                                       ng-click="$ctrl.updateStatus(alerta, 'REVISADO')"
                                                       ng-style="alerta.status != 'REVISADO' ? {color: '#bcb7b7'} : {}"
                                                       tooltip="Marcar como &quot;{{alerta.status == 'REVISADO' ? 'Não revisado' : 'Revisado'}}&quot;"
                                                       tooltip-placement="bottom"></i>
                                                    <i class="fa fa-exclamation-triangle text-warning cursor-pointer"
                                                       ng-click="$ctrl.updateStatus(alerta, 'ANALISE')"
                                                       ng-style="alerta.status != 'ANALISE' ? {color: '#bcb7b7'} : {}"
                                                       tooltip="Marcar como &quot;{{alerta.status == 'ANALISE' ? 'Não revisado' : 'Em análise'}}&quot;"
                                                       tooltip-placement="bottom"></i>
                                                </td>
                                                <td class="text-center-middle">
                                                    <i class="fa fa-list-alt cursor-pointer"
                                                       ng-click="$ctrl.openAlertaHistoricoModal(alerta)"
                                                       tooltip="Exibir histórico de revisão"
                                                       tooltip-placement="bottom"></i>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <cursor-paginator per-page="$ctrl.perPage" next-page="$ctrl.nextPage" previous-page="$ctrl.previousPage"
                            current-page="$ctrl.currentPage" current-page-size="$ctrl.nfes.length" 
                            on-change="$ctrl.pageChange($page)" search-context="$ctrl.searchContext">
                        </cursor-paginator>
                        ${batchUpdateOptions()}
                    </div>
                </loading>
            `
        }
    })
